<div class="oase-kategorieeintrag">

	<mat-card appearance="outlined">
		<mat-card-title>
			{{ OBJ_LNG_NAME+'.liste' | translate:locale.language }} <span *ngIf="dataSource" class="anzahl"> ({{ 'allgemein.daten.insgesamt' | translate:locale.language:{ count: dataSource.page.totalElements } }})</span>
			<p class="errors" *ngIf="dataService.fehler" [innerHTML]="dataService.fehler.messagehtml"></p>
			<p class="errors" *ngIf="fehlerMain" [innerHTML]="fehlerMain.messagehtml"></p>
		</mat-card-title>

		<mat-card-content>

			<div class="tabelle">
				<div class="tabelle-kopf" [style.display]="">
					<mat-form-field>
						<input matInput #filter>
						<mat-label>
							<i class="material-icons app-input-icon">search</i> {{ 'allgemein.suche' | translate:locale.language }}
						</mat-label>
						<button matSuffix mat-icon-button class="suche" (click)="clearFilter()" matTooltip="{{ 'allgemein.klick.leeresuche' | translate:locale.language }}"
								[disabled]="dataSource.isWaitingForResponse || filter.value == ''"><mat-icon>close</mat-icon></button>
					</mat-form-field>
				</div>

				<!-- Wenn eine Auswahl nicht benötigt wird einfach in displayedColumns die Spalte select nicht einbinden -->

				<div class="ladedaten" *ngIf="dataSource.isWaitingForResponse">
					<div>{{ 'allgemein.daten.laden.start' | translate:locale.language }} <mat-icon>free_breakfast</mat-icon></div>
					<div><mat-spinner color="primary"></mat-spinner></div>
					<div>{{ 'allgemein.daten.laden.ende' | translate:locale.language }}</div>
				</div>

				<mat-table #table [dataSource]="dataSource" matSort  [style.display]="onDesktop()">
					<ng-container *ngIf="isUnterschriftFaehig()" matColumnDef="unterschrift">
						<mat-header-cell *matHeaderCellDef  fxFlex="9">{{ OBJ_LNG_NAME+'.unterschrift' | translate:locale.language }}</mat-header-cell>
						<mat-cell fxFlex="9" *matCellDef="let row">
						<button *ngIf="showUnterzeichnenButton(row)" mat-raised-button [ngClass]="{'green-bg' : showUnterzeichnenButton(row)}" (click)="setUnterzeichnet(row)">{{ OBJ_LNG_NAME+'.unterzeichnen' | translate:locale.language}}</button>
						<button *ngIf="showUnterschriftZurueckziehenButton(row)" mat-raised-button [ngClass]="{'accent-bg' : showUnterschriftZurueckziehenButton(row)}" (click)="unterzeichnungAufheben(row)">{{ OBJ_LNG_NAME+'.aufhebung' | translate:locale.language}}</button>
						</mat-cell>
					</ng-container>
					<ng-container matColumnDef="check">
						<mat-header-cell *matHeaderCellDef  fxFlex="7">{{ OBJ_LNG_NAME+'.gelesen' | translate:locale.language }}?</mat-header-cell>
						<mat-cell fxFlex="7" *matCellDef="let row">
						<button *ngIf="!row.betrachtet" mat-raised-button [ngClass]="{'primary-bg' : !row.betrachtet}"  (click)="setBetrachtet(row)">{{ OBJ_LNG_NAME+'.gelesen' | translate:locale.language}}</button>
						<mat-icon *ngIf="row.betrachtet">check</mat-icon>
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="titel">
						<mat-header-cell *matHeaderCellDef  fxFlex="70">{{ OBJ_LNG_NAME+'.titel' | translate:locale.language }}</mat-header-cell>
						<mat-cell fxFlex="70" *matCellDef="let row">{{ row.text }}</mat-cell>
					</ng-container>

					<ng-container matColumnDef="download">
						<mat-header-cell *matHeaderCellDef  fxFlex="25">{{ 'allgemein.download' | translate:locale.language }}</mat-header-cell>
						<mat-cell fxFlex="25" *matCellDef="let row">
							<a class="eintrag_download_button shorten-long-text" *ngFor="let anhang of row.anhang" mat-raised-button (click)="download(row, anhang)" matTooltip="{{ 'allgemein.download' | translate:locale.language }}" target="_blank">{{anhang.name}}</a>
						</mat-cell>
					</ng-container>

					<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
					<mat-row *matRowDef="let row; columns: displayedColumns; let i = index;" ></mat-row>
				</mat-table>

				<div class="sucheleer" [style.display]="dataSource.page.totalElements > 0 && dataSource.page.searchElements == 0 ? '' : 'none'">
					{{ 'allgemein.daten.sucheleer' | translate:locale.language }}
				</div>

				<div class="keinedaten" [style.display]="dataSource.page.totalElements == 0 ? '' : 'none'">
					{{ 'allgemein.daten.keine' | translate:locale.language }}
				</div>

				<mat-paginator #paginator
							   [length]="dataSource.page.searchElements"
							   [pageIndex]="0"
							   [pageSize]="10"
							   [pageSizeOptions]="[5,10,15,20,25,30,50,100,200,500]">
				</mat-paginator>
			</div>
		</mat-card-content>
	</mat-card>

	<div [style.display]="onMobile()" class="mobile">

		<mat-card appearance="outlined" *ngFor="let eintrag of dataSource.content">
			<mat-card-title>

			</mat-card-title>
			<mat-card-subtitle>
			</mat-card-subtitle>
			<mat-card-content>
				{{ eintrag.text }} <br /><br />
				<span *ngIf="eintrag.anhang != null" style="color: rgba(0, 0, 0, 0.54); font-size:12px;">{{ 'allgemein.download' | translate:locale.language }}</span>
				<a class="eintrag_download_button shorten-long-text" *ngFor="let anhang of eintrag.anhang" mat-raised-button (click)="download(eintrag, anhang)" matTooltip="{{ 'allgemein.download' | translate:locale.language }}" target="_blank">{{anhang.name}}</a>
			</mat-card-content>
			<mat-card-actions align="end">
				<button *ngIf="!eintrag.betrachtet" mat-raised-button [ngClass]="{'accent-bg' : !eintrag.betrachtet}"  (click)="setBetrachtet(eintrag)">{{ OBJ_LNG_NAME+'.gelesen' | translate:locale.language}}</button>
				<div *ngIf="eintrag.betrachtet"><span style="color: rgba(0, 0, 0, 0.54); font-size:12px;">{{ OBJ_LNG_NAME+'.eintragGelesen' | translate:locale.language }}</span><mat-icon >check</mat-icon></div>
				<button *ngIf="showUnterzeichnenButton(eintrag)" mat-raised-button [ngClass]="{'green-bg' : showUnterzeichnenButton(eintrag)}" (click)="setUnterzeichnet(eintrag)">{{ OBJ_LNG_NAME+'.unterzeichnen' | translate:locale.language}}</button>
				<button *ngIf="showUnterschriftZurueckziehenButton(eintrag)" mat-raised-button [ngClass]="{'accent-bg' : showUnterschriftZurueckziehenButton(eintrag)}" (click)="unterzeichnungAufheben(eintrag)">{{ OBJ_LNG_NAME+'.aufhebung' | translate:locale.language}}</button>
			</mat-card-actions>
		</mat-card>
	</div>
</div>